export
{

};

export default {
    path: '/booking',
    name: 'Book Appointment',
    meta: {
        allowAnonymous: true,
        title: 'Book Appointment'
    },
    component: () => import( './Booking.vue' )
};